module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--预订条款 tip 模板-->\r\n\r\n<div class="hli-order-clause-wrap">\r\n	<ul class="hli-order-clause-list">\r\n		';
 for (var i = 0; i < clauses.length; i++) { var clause = clauses[i] ;
__p += '\r\n		<li class="hli-order-clause-item">\r\n			<h2>' +
((__t = ( clause.name )) == null ? '' : __t) +
'</h2>\r\n			<p>' +
((__t = ( clause.tip )) == null ? '' : __t) +
'</p>\r\n		</li>\r\n		';
 } ;
__p += '\r\n	</ul>\r\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelPriceUtil/templates/orderClauseTipTmpl.ejs
// module id = 86
// module chunks = 1 2 3 6 10